import { useNavigate } from 'react-router-dom';

export default function Legal({ type }) {
  const navigate = useNavigate();

  const privacy = (
    <>
      <h1 style={S.title}>Privacy Policy</h1>
      <p style={S.date}>Last updated: March 2026</p>

      <h2 style={S.h2}>What we collect</h2>
      <p style={S.p}>We collect your email address, full name, and password when you create an account. We also collect scripts you generate and your payment information (processed securely by Stripe — we never see your card details).</p>

      <h2 style={S.h2}>How we use it</h2>
      <p style={S.p}>We use your information to provide the SayIt service, send your verification code via email, process payments, and improve the product. We do not sell your data to anyone.</p>

      <h2 style={S.h2}>Email</h2>
      <p style={S.p}>We send you a one-time verification code when you sign in. We may send product updates occasionally. You can opt out anytime.</p>

      <h2 style={S.h2}>storage</h2>
      <p style={S.p}>Your data is stored securely Passwords are encrypted.</p>

      <h2 style={S.h2}>Third-Party Services</h2>
      <p style={S.p}>
          We use third-party service providers to support features such as payments, email delivery, and data storage. These providers may process your information as necessary to perform their functions and are governed by their own privacy policies.
      </p>

      <h2 style={S.h2}>Your rights</h2>
      <p style={S.p}>You can request deletion of your account and data at any time by emailing us. We will delete your data within 30 days.</p>

      <h2 style={S.h2}>Contact</h2>
      <p style={S.p}>Questions? Email us</p>
    </>
  );

  const terms = (
    <>
      <h1 style={S.title}>Terms of Service</h1>
      <p style={S.date}>Last updated: March 2026</p>

      <h2 style={S.h2}>Acceptance</h2>
      <p style={S.p}>By using SayIt you agree to these terms. If you don't agree, don't use the service.</p>

      <h2 style={S.h2}>What SayIt is</h2>
      <p style={S.p}>SayIt is an AI-powered tool that generates communication scripts for difficult conversations. Scripts are suggestions only — you are responsible for how you use them.</p>

      <h2 style={S.h2}>Your account</h2>
      <p style={S.p}>You are responsible for keeping your account secure. Don't share your login credentials. You must be 18 or older to use SayIt.</p>

      <h2 style={S.h2}>Payments</h2>
      <p style={S.p}>Pack subscriptions are billed monthly at $9 per pack. You can cancel anytime from your billing portal. No refunds for partial months.</p>

      <h2 style={S.h2}>Acceptable use</h2>
      <p style={S.p}>Don't use SayIt to harass, threaten, or harm others. Don't attempt to reverse engineer or abuse the service. We reserve the right to terminate accounts that violate these terms.</p>

      <h2 style={S.h2}>disclaimer</h2>
      <p style={S.p}>SayIt is not a substitute for professional legal, medical, or psychological advice.</p>

      <h2 style={S.h2}>Liability</h2>
      <p style={S.p}>SayIt is provided as-is. We are not liable for outcomes resulting from use of our scripts. Use your own judgment.</p>

      <h2 style={S.h2}>Changes</h2>
      <p style={S.p}>We may update these terms. Continued use after changes means you accept them.</p>

      <h2 style={S.h2}>Contact</h2>
      <p style={S.p}>Questions? Email us</p>
    </>
  );

  return (
    <div style={S.page}>
      <div style={S.glow1} />
      <div style={S.glow2} />

      <header style={S.header}>
        <div style={S.headerInner}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} onClick={() => navigate('/')}>
            <span style={{ fontSize: 20 }}>⚡</span>
            <span style={S.logoText}>SayIt</span>
            <span style={S.logoBeta}>BETA</span>
          </div>
          <button onClick={() => navigate(-1)} style={S.backBtn}>← Back</button>
        </div>
      </header>

      <div style={S.inner}>
        {type === "privacy" ? privacy : terms}
      </div>

      <footer style={S.footer}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: "#2a2a35", marginBottom: 8 }}>⚡ SayIt</div>
        <p style={{ fontSize: 13, color: "#252525" }}>Say what needs to be said. Exactly.</p>
      </footer>
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    background: "#0C0C0E",
    color: "#E8E8EC",
    fontFamily: "'DM Sans', sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  glow1: {
    position: "fixed",
    top: -100, right: -100,
    width: 400, height: 400,
    background: "rgba(124,58,237,0.1)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  glow2: {
    position: "fixed",
    bottom: -100, left: -100,
    width: 400, height: 400,
    background: "rgba(74,222,128,0.06)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  header: {
    borderBottom: "1px solid #1E1E28",
    padding: "0 24px",
    position: "sticky",
    top: 0,
    background: "rgba(12,12,14,0.96)",
    backdropFilter: "blur(16px)",
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 960,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
  },
  logoText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: "#E8E8EC",
  },
  logoBeta: {
    fontSize: 10,
    fontWeight: 600,
    color: "#C8A96E",
    border: "1px solid #C8A96E",
    borderRadius: 4,
    padding: "2px 6px",
    letterSpacing: "0.08em",
  },
  backBtn: {
    background: "none",
    border: "none",
    color: "#555",
    cursor: "pointer",
    fontSize: 14,
    fontFamily: "'DM Sans', sans-serif",
  },
  inner: {
    maxWidth: 720,
    margin: "0 auto",
    padding: "60px 24px 80px",
    position: "relative",
    zIndex: 1,
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 40,
    fontWeight: 900,
    color: "#F0F0F5",
    marginBottom: 8,
  },
  date: {
    fontSize: 13,
    color: "#444",
    marginBottom: 48,
  },
  h2: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 700,
    color: "#D0D0DC",
    marginTop: 36,
    marginBottom: 12,
  },
  p: {
    fontSize: 15,
    color: "#666",
    lineHeight: 1.8,
  },
  footer: {
    borderTop: "1px solid #1E1E28",
    padding: "40px 24px",
    textAlign: "center",
  },
};